import { extendedPropertyFlags, extendedPropertyFlagsEnum, extendedPropertyKindsEnum } from "helpers/enums";
import { buildQuery } from "helpers/reqparams";
import { flagVal } from "helpers/system";
import { alertRequest, body, request } from "services/request";

const hiddenFlagVal = flagVal(extendedPropertyFlags, extendedPropertyFlagsEnum.Invisible);

const resource = "api/extendedproperties";

const getAllProperties = () => {
    const query = buildQuery({ orderBy: "order asc" });
    return request(`${resource}/get${query}`, { method: "GET" });
};

const getOrganizationProperties = (organizationId: number) => {
    const query = buildQuery({ filter: { organizationId } });
    return request(`${resource}/getAll${query}`, { method: "GET" });
};

const deleteItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const applyItem = (params: {}) => alertRequest(`${resource}/apply`, body(params));

type ExtendedPropsModel = { isExtendedProperty: boolean; kind: keyof typeof extendedPropertyKindsEnum };

const getCombinedProperties = ({ excludeHidden = false, isRelation = false }) => {
    return getAllProperties().then((data) => {
        if (excludeHidden) {
            data = data.filter((item: { intRelationFlags: number; intFlags: number }) => {
                const intFlags = isRelation ? item.intRelationFlags : item.intFlags;
                return (intFlags & hiddenFlagVal) !== hiddenFlagVal;
            });
        }
        const res: {
            bid: ExtendedPropsModel[];
            cargo: ExtendedPropsModel[];
            bidPoint: ExtendedPropsModel[];
        } = { bid: [], cargo: [], bidPoint: [] };
        data.forEach((item: ExtendedPropsModel) => {
            item.isExtendedProperty = true;
            switch (item.kind) {
                case extendedPropertyKindsEnum.Bid:
                    res.bid.push(item);
                    break;
                case extendedPropertyKindsEnum.BidCargo:
                    res.cargo.push(item);
                    break;
                case extendedPropertyKindsEnum.BidPoint:
                    res.bidPoint.push(item);
                    break;
            }
        });
        return res;
    });
};

const changeFlags = (params: {}) => alertRequest(`${resource}/changeFlags`, body(params));

export { getAllProperties, getCombinedProperties, deleteItem, applyItem, getOrganizationProperties, changeFlags };
